import { useCallback, useEffect, useMemo } from 'react'
import { compose, hoc, useStore } from '@'
import { check } from 'components/can'
import GetCatalogs from '../../actions/GetCatalogs'
import GetHotelCoverage from '../../actions/GetHotelCoverage'
import DeleteHotel from '../../actions/DeleteHotel'
import UpdateHotel from '../../actions/UpdateHotel'
import OpenHotelEditor from '../../actions/OpenHotelEditor'
import OpenHotelRegionForm from '../../actions/OpenHotelRegionForm'
import { $hotelCoverage, $hotelCoverageLoading, $hotelCoverageQuery } from '../../stores'
import { RESOURCE, confirmDanger, useUrlQuery } from '../CoverageCommon'

const QUERY_FIELDS = ['hotel_id']

const container = compose(
    hoc(props => {
        const [hotelCoverage, loading, query] = useStore([$hotelCoverage, $hotelCoverageLoading, $hotelCoverageQuery])

        useUrlQuery($hotelCoverageQuery, QUERY_FIELDS, GetHotelCoverage)

        useEffect(() => {
            GetCatalogs().catch(console.error)
        }, [])

        const perms = useMemo(
            () => ({
                create: check(RESOURCE, 'create'),
                edit: check(RESOURCE, 'edit'),
                delete: check(RESOURCE, 'delete')
            }),
            []
        )

        const handleCreate = useCallback(hotelId => {
            OpenHotelEditor('create', { hotel_id: hotelId }).catch(console.error)
        }, [])

        const handleEdit = useCallback(hotel => {
            OpenHotelEditor('edit', hotel).catch(console.error)
        }, [])

        const handleDelete = useCallback(hotel => {
            confirmDanger({
                title: `Delete hotel ${hotel.hotel_id}?`,
                content: `This deletes its hotel_mapping_provider row and all ${hotel.regions.length} region link(s) in hotel_mapping_v2. The hotel will no longer appear in search.`,
                okText: 'Delete',
                onOk: () => DeleteHotel(hotel.hotel_id)
            })
        }, [])

        const handleAddRegion = useCallback(hotel => {
            OpenHotelRegionForm(hotel.hotel_id).catch(console.error)
        }, [])

        const handleRemoveRegion = useCallback((hotel, region) => {
            confirmDanger({
                title: `Remove region ${region.region_id} from hotel ${hotel.hotel_id}?`,
                content: `Deletes the ${region.supplier_code} link. Searches for this region will stop returning the hotel unless another link remains.`,
                okText: 'Remove',
                onOk: () =>
                    UpdateHotel(hotel.hotel_id, {
                        remove_regions: [{ region_id: region.region_id, supplier_code: region.supplier_code }]
                    })
            })
        }, [])

        return {
            hotelCoverage,
            loading,
            query,
            perms,
            handleCreate,
            handleEdit,
            handleDelete,
            handleAddRegion,
            handleRemoveRegion,
            ...props
        }
    })
)

export default container
